import ActionTextIcon from "@/components/icons/ActionTextIcon";
import AntIcon from "@/components/icons/AntIcon";
import Ellipsis from "@/components/views/Ellipsis";
import { paginationTableProps, tableStandardProps } from "@/utils/componentUtils";
import { Popconfirm, Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useTranslation } from "react-i18next";
import { useAgentGetUserInvitationsByAgent, useAgentResendUserInvitation } from "../../../../common/api/queries";
import { PageSizes } from "../../../../common/constants";
import { AgentUserInvitation } from "../../../user/types";

type Props = {
  agentId: string;
};

export const AgentUserInvitationsTable = ({ agentId }: Props) => {
  const { t } = useTranslation();

  const { data, isFetching } = useAgentGetUserInvitationsByAgent(agentId);
  const resendUserInvitation = useAgentResendUserInvitation();

  const columns: ColumnsType<AgentUserInvitation> = [
    {
      key: "name",
      title: t("user.attrs.name"),
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.name}</Ellipsis>,
    },
    {
      key: "email",
      title: t("user.attrs.email"),
      ellipsis: { showTitle: false },
      render: (_, record) => <Ellipsis>{record.email || record.emailToConfirm}</Ellipsis>,
    },
    {
      key: "actions",
      align: "right",
      fixed: "right",
      width: 180,
      render: (_, record) => (
        <Popconfirm
          title={t("user.titles.resendInvitationConfirm")}
          icon={<AntIcon type="question" />}
          cancelText={t("common.no")}
          okText={t("common.yes")}
          onConfirm={() => resendUserInvitation.mutate({ id: record.id })}
        >
          <ActionTextIcon icon="mail" color="blue" text={t("user.actions.resendInvitation")} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <Table<AgentUserInvitation>
      {...tableStandardProps<AgentUserInvitation>()}
      loading={isFetching}
      columns={columns}
      dataSource={data}
      pagination={{ ...paginationTableProps, pageSize: PageSizes.SMALL }}
    />
  );
};
